import {Link} from 'react-router-dom';
import './LegalText.scss';

const LegalHintsText = () => {
    return (<div className="legal-text">
            <div className="legal-text-header">
                <h4>
                    Rechtliche Hinweise
                </h4>
            </div>
            <p>
                Die Sportcast GmbH (<b>„Sportcast“</b>) freut sich über Ihr Interesse und die Nutzung ihres Qualitätsmanagementtools unter
                report.sportcast.de (nachfolgend zusammenfassend <b>&quot;Portal&quot;</b>).
            </p>
            <span className="header-span">
                1. Haftungsbeschränkung
            </span>
            <p>
                Die Inhalte des Portals wurden mit größtmöglicher Sorgfalt erstellt. Die Sportcast übernimmt jedoch keine Gewähr für die Richtigkeit,
                Vollständigkeit, Aktualität oder sonstige Qualität der bereitgestellten Inhalte. Die Nutzung der Inhalte des Portals erfolgt auf
                eigene Gefahr des Nutzers. Namentlich gekennzeichnete Beiträge geben die Meinung des jeweiligen Autors und nicht immer die Meinung der
                Sportcast wieder. Mit der reinen Nutzung des Portals kommt keinerlei Vertragsverhältnis zwischen dem Nutzer und der Sportcast
                zustande. Die Haftung für Schäden, gleich aus welchem Rechtsgrund und welcher Art, wird ausgeschlossen, soweit diese nicht auf Vorsatz
                oder grober Fahrlässigkeit beruhen.
            </p>

            <span className="header-span">
                2. Geistiges Eigentum, Urheber- und Schutzrechte
            </span>
            <p>
                2.1 Alle Rechte sind vorbehalten. Das auf dem Portal enthaltene geistige Eigentum ist geschützt. Mit dem Portal wird dem Nutzer keine
                Lizenz zur Nutzung oder Verwertung des geistigen Eigentums der Sportcast eingeräumt. Insbesondere unterliegen die auf dem Portal
                veröffentlichten Inhalte, wie z.B. Text, Bilder, Grafiken, Sound, Animationen und Videos, sowie deren Anordnung dem deutschen Urheber-
                und Leistungsschutzrecht sowie anderen Schutzgesetzen. Jede vom deutschen Urheber- und Leistungsschutzrecht nicht zugelassene Nutzung
                oder Verwertung bedarf der vorherigen schriftlichen Zustimmung der Sportcast oder jeweiligen Rechteinhabers. Dies gilt insbesondere
                für Vervielfältigung, Bearbeitung, Übersetzung, Einspeicherung, Verarbeitung bzw. Wiedergabe von Inhalten in Datenbanken oder anderen
                elektronischen Medien und Systemen. Die unerlaubte Vervielfältigung oder Weitergabe einzelner Inhalte oder kompletter Seiten ist nicht
                gestattet. Lediglich die Herstellung von Kopien und Downloads für den persönlichen, privaten und nicht kommerziellen Gebrauch ist
                erlaubt. Die Darstellung des Portals in fremden Frames ist nur mit schriftlicher Erlaubnis zulässig. Der Nutzer wird darauf
                hingewiesen, dass die auf dem Portal enthaltenen Inhalte teilweise den Urheberrechten Dritter unterliegen. Sollte der Nutzer auf eine
                Rechtsverletzung aufmerksam werden, bittet die Sportcast um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen
                wird die Sportcast derartige Inhalte umgehend entfernen.
            </p>
            <p>
                2.2 Die Sportcast behält sich gemäß § 44b Abs. 3 UrhG ausdrücklich die Vervielfältigung der auf diesem Portal verfügbaren Inhalte für
                Zwecke des Text und Data Mining vor. Jegliche automatisierten Programme, Applets, Bots oder ähnliche Technologien dürfen nicht zum
                Zugriff, zur Analyse oder zum Download der über dieses Portal verbreiteten Inhalte verwendet werden. Dies gilt insbesondere für die
                Nutzung der über dieses Portal verbreiteten Inhalte für das Training von KI-Systemen.
            </p>
            <p>
                <i>
                    Pursuant to Section 44b para. 3 of the German Act on Copyright and Related Rights (Urheberrechtsgesetz, “UrhG”), the Sportcast
                    expressly reserves the right to reproduce the content available on this Portal for the purposes of text and data mining. Any
                    automated
                    programmes, applets, bots or similar technologies may not be used to access, analyse or download the content distributed via this
                    Portal. This applies in particular to the use of the content distributed via this Portal for training AI systems.
                </i>
            </p>

            <span className="header-span">
                3.Marken- und Kennzeichenrechte
            </span>
            <p>
                Sämtliche auf dem Portal genannten oder abgebildeten Marken- und Kennzeichen der Sportcast sind rechtlich geschützt. Dies gilt
                insbesondere für Marken, Logos und Embleme. Auch alle übrigen innerhalb des Portals genannten oder abgebildeten Marken- und
                Kennzeichen Dritter unterliegen uneingeschränkt den Bestimmungen des jeweils gültigen Marken- und Kennzeichenrechts der jeweiligen
                Inhaber. Allein die Nennung oder Abbildung bedeutet ausdrücklich nicht, dass solche Marken- oder Warenzeichen nicht durch die Rechte
                Dritter geschützt sind.
            </p>

            <span className="header-span">
                4. Verweise und Links
            </span>
            <p>
                Das Portal enthält Verknüpfungen zu Websites Dritter (&quot;externe Links&quot;). Diese Websites unterliegen der Haftung der
                jeweiligen Betreiber. Die Sportcast hat bei der erstmaligen Verknüpfung der externen Links die fremden Inhalte daraufhin überprüft, ob
                etwaige Rechtsverstöße bestehen. Zu dem Zeitpunkt waren keine Rechtsverstöße ersichtlich. Die Sportcast hat keinerlei Einfluss auf die
                aktuelle und zukünftige Gestaltung und auf die Inhalte der verknüpften Seiten. Das Setzen von externen Links bedeutet nicht, dass sich
                die Sportcast die hinter dem Verweis oder Link liegenden Inhalte zu Eigen macht. Eine ständige Kontrolle der externen Links ist für
                die Sportcast ohne konkrete Hinweise auf Rechtsverstöße nicht zumutbar. Bei Kenntnis von Rechtsverstößen werden jedoch derartige
                externe Links unverzüglich gelöscht.
            </p>
            <span className="header-span">
                5. Leistungen Dritter
            </span>
            <p>
                Werden auf dem Portal von Dritten Waren oder Dienstleistungen angeboten, muss der Nutzer im Fall der Bestellung deren vertragliche
                Bedingungen akzeptieren, da für das Vertragsverhältnis zwischen dem Nutzer und dem Dritten ausschließlich die vertraglichen
                Bedingungen des Dritten gelten. Fragen und Reklamationen sind daher direkt an den jeweiligen Dritten zu richten, dessen vertragliche
                Bedingungen gelten.
            </p>
            <span className="header-span">
                6. Datenschutz
            </span>
            <p>
                Die Datenschutzerklärung des Portals kann unter folgendem <Link to="/data-privacy" target="_blank"
                                                                                rel="noreferrer">Link</Link> eingesehen werden.
            </p>

            <div className="text-end mt-4">Stand: 01.07.2023</div>
        </div>
    );
};
export default LegalHintsText;